export const HISTORY_PANEL_ID = "history";
